import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../constants/common'
import { Checkbox, CHECKBOX_SIZE } from '../../../Checkbox'
import { FormActions, FormButtonAdd } from '../../../Form'
import { FormikField, getFormikCheckboxFieldValueProps } from '../../../Formik'
import {
  CONNECTED_REQUESTS_MASS_EDIT_FORM_FIELD_NAMES,
  QA_NAME_ADD_PARAMETER_BUTTON,
} from '../ConnectedRequestsMassEditModal.constants'
import {
  createEmptyParameter,
  getCanAddParameter,
} from '../ConnectedRequestsMassEditModal.utils'

import * as styles from '../ConnectedRequestsMassEditModal.module.css'

function ConnectedRequestsMassEditModalActions({
  className = styles.actions,
  ...restProps
}) {
  const { t } = useTranslation()

  const { setFieldValue, values } = useFormikContext()

  const parameters =
    values[CONNECTED_REQUESTS_MASS_EDIT_FORM_FIELD_NAMES.parameters] ||
    EMPTY_LIST
  const canAddParameter = getCanAddParameter(parameters)

  function handleAddParameter() {
    if (canAddParameter) {
      setFieldValue(CONNECTED_REQUESTS_MASS_EDIT_FORM_FIELD_NAMES.parameters, [
        ...parameters,
        createEmptyParameter(),
      ])
    }
  }

  return (
    <FormActions
      {...restProps}
      ButtonAdd={FormButtonAdd}
      addProps={{
        disabled: !canAddParameter,
        qaName: QA_NAME_ADD_PARAMETER_BUTTON,
        title: 'ConnectedRequestsMassEdit.AddParameterButtonKey',
        onClick: handleAddParameter,
      }}
      className={className}
    >
      <FormikField
        Component={Checkbox}
        Field={Fragment}
        className={styles.actionsCheckboxWrapper}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t(
          'ConnectedRequestsMassEdit.ExcludeArchivedRequestsCheckboxKey'
        )}
        labelClassName={styles.actionsCheckbox}
        labelTitleClassName={styles.actionsCheckboxTitle}
        name={CONNECTED_REQUESTS_MASS_EDIT_FORM_FIELD_NAMES.excludeArchived}
        size={CHECKBOX_SIZE.small}
      />
    </FormActions>
  )
}

export default ConnectedRequestsMassEditModalActions
